import { Button } from "@shared/ui/button";
import { Card } from "@shared/ui/card";
import {
  ClipboardList,
  Edit,
  Zap,
  Trash2,
} from "lucide-react";
import { useNavigate, useParams } from "react-router-dom";
import { usePatchMeterReadingFormat, useDeleteMeterReadingFormat } from "../../../hooks";
import { useRemoteUtilityId } from "@shared/selectors/globalSelectors";

export const QuickActions = ({ meterReadingFormatDetail }: { meterReadingFormatDetail: any }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const remoteUtilityId = useRemoteUtilityId();
  const { mutate: updateFormat } = usePatchMeterReadingFormat();
  const { mutate: deleteFormat } = useDeleteMeterReadingFormat();

  const handleDeactivate = () => {
    const payload = {
      remote_utility_id: Number(remoteUtilityId),
      is_active: !meterReadingFormatDetail?.isActive, // toggle the value
    };
    updateFormat(
      { id: Number(id), payload },
    );
  };

  const handleDelete = () => {
    deleteFormat(Number(id), {
      onSuccess: () => {
        navigate("/mx/settings/meterread-format?tab=read-format");
      },
    });
  };

  return (
    <Card className="p-6 h-full border border-gray-200 shadow-sm">
      <div className="flex items-center gap-2 mb-6">
        <Zap className="h-5 w-5 text-amber-500" />
        <h3 className="font-semibold text-lg">Quick Actions</h3>
      </div>

      <div className="space-y-4">
        <Button
          className="w-full justify-start gap-3 h-12 text-gray-700 border-gray-200"
          variant="outline"
          onClick={() =>
            navigate(
              `/mx/settings/meterread-format/edit/${meterReadingFormatDetail?.id}`
            )
          }
        >
          <Edit className="h-5 w-5 text-gray-500" />
          <span className="font-medium">Edit Format</span>
        </Button>

        <Button
          className={`w-full justify-start gap-3 h-12 ${
             !meterReadingFormatDetail?.isActive
               ? "bg-green-600 hover:bg-green-700 text-white"
               : "text-gray-700 border-gray-200"
           }`}
          variant={meterReadingFormatDetail?.isActive ? "outline" : "default"}
          onClick={handleDeactivate}
        >
          <ClipboardList className="h-5 w-5" />
          <span className="font-medium">
            {meterReadingFormatDetail?.isActive ? "Deactivate Format" : "Activate Format"}
          </span>
        </Button>
      </div>
    </Card>
  );
};
